import type { Moment } from 'moment';

import type { DateTimeDisplayString, DateTimePatternJSON } from './_.type';

import datetimeConfig from '../_config';

const { format } = datetimeConfig;

/** Override Functions. */
export const overrideFunctions = {
  toJSON(this: Moment): string | null {
    if (!this.isValid()) {
      return null;
    }

    return this.toISOString().replace(/\.\d+Z$/, 'Z');
  },
};

/** Extend Function. */
export const extendFunctions = {
  toLocalJson(this: Moment): string | null {
    if (!this.isValid()) {
      return null;
    }

    return this.format(format.json.datetime);
  },

  /**
   * Convert to pattern JSON.
   *
   * @returns {DateTimePatternJSON} Pattern JSON.
   */
  toPatternJSON(this: Moment): DateTimePatternJSON {
    return {
      date: this.format(format.json.date),
      time: this.format(format.json.time),
    };
  },

  /**
   * Convert to Display string.
   *
   * @returns {DateTimeDisplayString} Display string.
   */
  toDisplayString(this: Moment): DateTimeDisplayString {
    return {
      date: this.format(format.display.date),
      time: this.format(format.display.time),
      datetime: this.format(format.display.datetime),
    };
  },
};
